export default __webpack_public_path__ + "static/media/Skup Pula (3).1d3565b6.JPG";